// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._2XDho{background:#fff;list-style:none}._1Csya{fill:#452aec;height:14px;height:1.4rem;margin-top:-.7rem;position:absolute;top:calc(50% + 1rem);width:14px;width:1.4rem}html[dir=ltr] ._1Csya{right:20px;right:2rem}html[dir=rtl] ._1Csya{left:20px;left:2rem}", ""]);
// Exports
exports.locals = {
	"organizations": "_2XDho",
	"search__loupe": "_1Csya"
};
module.exports = exports;
